import { Injectable } from '@angular/core';
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TriggerEventCommunicationService {

    // *****************************
    // This Services is used to upload right-content-component task list when a new task added
    // *****************************

    private eventTriggerSubject = new Subject<void>();

    eventTriggerObservable = this.eventTriggerSubject.asObservable();

    triggerEvent() {
        console.log('TriggerEventCommunicationService Works');
        this.eventTriggerSubject.next();
    }
}
